// extracted by mini-css-extract-plugin
export default {"Boxes__title":"V0OyUXC6kdI4z1qELLZn","Boxes__small":"sb_7lqeLM8oXHdj5nzEY"};